import React, { useMemo } from 'react';
import { ChartConfig } from '../../types';
import { MapChartConfig } from './config/mapChartTypes';
import { DEFAULT_MAP_CONFIG } from './config/mapChartDefaults';
import { useMapData } from './hooks/useMapData';
import { SimpleMapView } from './SimpleMapView'; // Tableau-style SVG map (no API key needed)
// import { MapView } from './MapView'; // Mapbox-based map (requires VITE_MAPBOX_TOKEN)
import { MapChartConfigPanel } from './ui/MapChartConfigPanel';

export interface MapChartProps {
    data: any[];
    config: ChartConfig;
}

export const MapChart: React.FC<MapChartProps> = ({ data, config }) => {
    // Merge parent config with 3D defaults
    const mapConfig: MapChartConfig = useMemo(() => ({
        ...DEFAULT_MAP_CONFIG,
        ...(config.advanced?.mapConfig || {})
    }), [config.advanced?.mapConfig]);

    // Map parent config fields to map mapping
    const dataMapping = useMemo(() => ({
        latitudeField: config.latField || config.advanced?.map?.latField || '',
        longitudeField: config.lonField || config.advanced?.map?.lonField || '',
        valueField: config.valueField || config.advanced?.map?.valueField || '',
        categoryField: config.categoryField || config.advanced?.map?.categoryField || '',
        regionKeyField: config.advanced?.map?.regionKeyField || ''
    }), [config]);

    const mapData = useMapData(data, dataMapping);

    const mergedConfig: MapChartConfig = {
        ...mapConfig,
        ...dataMapping
    };

    return (
        <div className="w-full h-full flex flex-col">
            <SimpleMapView
                data={mapData}
                config={mergedConfig}
            />
        </div>
    );
};

// Re-export sub-components for the builder to use
export { MapChartConfigPanel };
export type { MapChartConfig };
